import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../RootReducer";
import {Dispatch} from "redux";
import {Spinner} from "../ui/Spinner";
import {Bundle, ListBundlesResponse, Settings, UserInfo} from "../http/protocol";
import {fetchStoreBundles} from "../store/StoreActions";
import {RouteComponentProps, withRouter} from "react-router-dom";
import BundleComponentLg from "./BundleComponentLg";
import ErrorBoundary from "./ErrorBoundary";
import {setUseAsStore} from "../payments/DepositActions";
import "./styles/BundlesLandingPage.scss";
import {WindowSize} from "../settings/SettingsReducer";
import BundleComponent from "./BundleComponent";
import {t} from "../i18n";
import { PATH } from "../onboardingpage/modalview/UserModalController";




type AllProps = PropsFromState & PropsFromDispatch & RouteComponentProps;

export class BundlesLandingPage extends Component<AllProps> {
    constructor(props: AllProps) {
        super(props);
    }

    componentDidMount(): void {
        if(this.props.bundles === undefined) {
            this.props.fetchStoreBundles();
            this.props.setUseAsStore&& this.props.setUseAsStore(true);
        }
    }
    handleOnClickBundle = (bundleId: number) => {
        this.props.history.push({search: new URLSearchParams({type: PATH.LOGIN, modal: PATH.MODAL_TYPE}).toString()});

    }

    comparePriceAscending = (a: number | undefined, b: number | undefined) => {
        return (a || b) ? (!a ? -1 : !b ? -1 : a-b) : 0;
    }

    comparePriceDescending = (a: number | undefined, b: number | undefined) => {
        return (a || b) ? (!a ? -1 : !b ? -1 : b-a) : 0;
    }

    compareDescending = (a: Bundle, b: Bundle) => {
        if(a.price && b.price) {
            return this.comparePriceDescending(a.price.amount, b.price.amount);
        } else {
            return 0;
        }
    }

    compareAscending = (a: Bundle, b: Bundle) => {
        if(a.price && b.price) {
            return this.comparePriceAscending(a.price.amount, b.price.amount);
        } else {
            return 0;
        }
    }

    render() {
        const {isFetching, bundles, user, windowSize} = this.props;
        return (
            <div className={"onLandingPageContainer"}>
                {
                    isFetching
                        ? <Spinner />
                        : user&& bundles&& bundles.items&&  bundles.items.filter((temp) => temp.featured).length > 0
                            ? (
                            <div>
                                <h1 className={"bundlesTitle"}>{t("store.bundles.title")}</h1>
                                <div className={"onLandingPage"}>
                                    <ErrorBoundary>
                                    {
                                        windowSize >= WindowSize.WIDTH_LG
                                            ? user&& bundles&& bundles.items&&  bundles.items.filter((temp) => temp.featured).sort((a, b) => this.compareAscending(a, b)).slice(0, 3).map((bundle, index) => {
                                                return  <BundleComponentLg
                                                            onClick={this.handleOnClickBundle}
                                                            key={index}
                                                            user={user}
                                                            bundle={bundle} />
                                                })
                                            :  user&& bundles&& bundles.items&&  bundles.items.filter((temp) => temp.featured).sort((a, b) => this.compareDescending(a, b)).slice(0, 3).map((bundle, index) => {
                                            return <BundleComponent
                                                        onClick={this.handleOnClickBundle}
                                                        key={index}
                                                        user={user}
                                                        bundle={bundle} />
                                                })
                                    }
                                    </ErrorBoundary>
                                </div>
                             </div>
                        )
                        : null
                }
            </div>
        )
    }
}


interface PropsFromState {
    isFetching: boolean;
    user?: UserInfo;
    bundles?: ListBundlesResponse;
    windowSize: number;
}

interface PropsFromDispatch {
    fetchStoreBundles: typeof fetchStoreBundles;
    setUseAsStore? : (setUseAsStore : boolean)=>void
}


const mapStateToProps = ({settings,user,  store} : AppState) => {
    return {
        isFetching: store.isFetching,
        user: user.user,
        bundles: store.bundles,
        windowSize: settings.windowSize
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        fetchStoreBundles: () => dispatch(fetchStoreBundles() as any),
        setUseAsStore : (useAsStore : boolean) => dispatch(setUseAsStore(useAsStore)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BundlesLandingPage));